import { ROUTES } from '@constants/routes';
import { Order, OrderStatus } from '@interfaces/order';

const SafeStatusesWithRedirectRoute: Partial<
  Record<OrderStatus, (id: string) => string>
> = {
  recalculate: ROUTES.recalculate,
  canceled_customer: ROUTES.feedbackSent,
  canceled_merchant: ROUTES.feedbackSent,
  create_error: ROUTES.noRequisite,
  no_payment_details: ROUTES.noRequisite,
  need_retry_payment_details_attempt: ROUTES.transaction,
  success: ROUTES.transactionSuccessfully,
  failed: ROUTES.paymentFailed,
};

export const getRedirectUrlByOrderStatus = (
  order: Order,
  isPaymentSearchActive: boolean,
  isReceiptsLimit: boolean,
  isReceiptDisabled: boolean,
  isOnReturnPage = false,
) => {
  const { id: orderId, status: orderStatus } = order;

  const safeRedirectRoute = SafeStatusesWithRedirectRoute[orderStatus];
  if (safeRedirectRoute) return safeRedirectRoute(orderId);

  if (isOnReturnPage) return undefined;

  if (orderStatus === 'expired') {
    return isPaymentSearchActive || !isReceiptDisabled
      ? ROUTES.transactionSendReceipt(orderId)
      : ROUTES.transaction(orderId);
  }

  if (isPaymentSearchActive) {
    return ROUTES.transactionSendReceipt(orderId);
  }

  if (isReceiptsLimit) {
    return ROUTES.transactionSendReceipt(orderId);
  }

  if (isReceiptDisabled && !isPaymentSearchActive) {
    return ROUTES.transaction(orderId);
  }
};

export const getRedirectUrlWithoutReceiptUpload = (
  order: Order,
  isOnReturnPage: boolean,
  isOnReceiptUploadPage: boolean
) => {
  const { id: orderId, status: orderStatus } = order;

  const safeRedirectRoute = SafeStatusesWithRedirectRoute[orderStatus];
  if (safeRedirectRoute) return safeRedirectRoute(orderId);

  if (isOnReturnPage) return undefined;

  if (orderStatus === 'expired' || isOnReceiptUploadPage) {
    return ROUTES.transaction(orderId);
  }
};

export const getRedirectUrlWithLocale = (
  redirectUrl: string,
  locale: string
) => {
  // Always include locale prefix for app router
  return `/${locale}${redirectUrl}`;
};
